import { createContext, useContext } from "react";

export const StackingZIndexContext = createContext<number | null>(null);

export const useParentZIndex = (): number | null =>
  useContext(StackingZIndexContext);
